// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://saiuvgbzhndvxmobkway.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNhaXV2Z2J6aG5kdnhtb2Jrd2F5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDcwNDQxMDksImV4cCI6MjA2MjYyMDEwOX0.LzbJ40koGwem1q-WLosYGS_3DcDYOvCOrF4w1yYSkig";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);